import React, { useState } from 'react';
import src1 from './images/Number 1.png';
import src2 from './images/Number 2.png';
import src3 from './images/Number 3.png';
import src4 from './images/Number 4.png';
import src5 from './images/Number 5.png';
import src6 from './images/Number 6.png';
import src7 from './images/Number 7.png';
import src8 from './images/Number 8.png';
import src9 from './images/Number 9.png';
import src10 from './images/Number 0.png';
import src11 from './images/Counter.png';
import Numsm from './Numsm';

const Nums = () => {
  const [NumsCounts, setNumsCounts] = useState({ '1': 1, '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '7': 1, '8': 1, '9': 1 , '10': 1, '11': 1});

  const maybeIncrementNumsCount = (color) => {
    setNumsCounts({...NumsCounts, [color]: NumsCounts[color] + 1});
  };


  const renderNums = (color) => {
    let nums = [];
    let numsImages = { '1': src1, '2': src2, '3': src3, '4': src4, '5': src5, '6': src6, '7': src7, '8': src8, '9': src9, '10': src10, '11': src11};
    let numbmax = { '1': 1, '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '7': 1, '8': 1, '9': 1, '10': 1, '11': 55};
    if(NumsCounts[color] > numbmax[color]){
      NumsCounts[color] = numbmax[color]
    }
    
    for (let i = 0; i < NumsCounts[color]; i++) {
      nums.push(
        <Numsm src={numsImages[color]} size={color} key={i} onStop={() => maybeIncrementNumsCount(color) } />
      );
    }
    return nums;
  }
  


  return (
        <div className="nums-mat">
          <div className="nums-holder">
            {renderNums('1')}
          </div>
          <div className="nums-holder">
            {renderNums('2')}
          </div>
          <div className="nums-holder">
            {renderNums('3')}
          </div>
          <div className="nums-holder">
            {renderNums('4')}
          </div>
          <div className="nums-holder">
            {renderNums('5')}
          </div>
          <div className="nums-holder">
            {renderNums('6')}
          </div>
          <div className="nums-holder">
            {renderNums('7')}
          </div>
          <div className="nums-holder">
            {renderNums('8')}
          </div>
          <div className="nums-holder">
            {renderNums('9')}
          </div>
          <div className="nums-holder">
            {renderNums('10')}
          </div>
          <div className="nums-holder">
            {renderNums('11')}
          </div>

        </div>
  );
};

export default Nums;

